import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";

// Hidden while the enquiry form or footer is on screen so it can never cover
// form fields, consent text, the submit button or footer links.
export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const targets = ["contact", "site-footer"]
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (!targets.length) return;
    const visible = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        setHidden(visible.size > 0);
      },
      { threshold: 0.05 }
    );
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, []);

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Enquire on WhatsApp (opens WhatsApp in a new tab)"
      data-testid="whatsapp-float-button"
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
      onClick={() => track(EVENTS.whatsappClick, { source: "floating-button" })}
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-30 inline-flex items-center gap-2 w-12 h-12 sm:w-auto sm:h-auto justify-center sm:px-4 sm:py-3 rounded-full bg-spice-whatsapp text-white text-xs font-bold shadow-lg hover:brightness-95 transition-opacity duration-300 ${
        hidden ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      <MessageCircle className="w-5 h-5 shrink-0" aria-hidden="true" />
      <span className="hidden sm:inline">Enquire on WhatsApp</span>
    </a>
  );
};
